const GAME_OBJECTS = {
    aidKit: {
        id: "aidKit",
        number: 1,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-aidkit.png",
        },
        image: "/images/game/chapter2/game-objects/aid-kit.png",
        title: "急救包",
        description: "內含藥品、繃帶等，必備的防災品。",
        importance: "備妥醫療用品，受傷可即時處理。",
        position: {
            x: 1038,
            y: 464
        },
        size: {
            width: 182,
            height: 119,
        },
    },
    basketball: {
        id: "basketball",
        number: 2,
        status: {
            default: "/images/game/chapter2/game-objects/min-basketball.png",
        },
        image: "/images/game/chapter2/game-objects/basketball.png",
        title: "籃球",
        description: "安西教練 …… 我很想打籃球！",
        position: {
            x: 1071,
            y: 221
        },
        size: {
            width: 129,
            height: 124,
        },
    },
    cake: {
        id: "cake",
        number: 3,
        status: {
            default: "/images/game/chapter2/game-objects/min-cake.png",
        },
        image: "/images/game/chapter2/game-objects/cake.png",
        position: {
            x: 700,
            y: 433
        },
        size: {
            width: 150,
            height: 155,
        },
        title: "22 歲生日蛋糕",
        description: "我不知道你，但我要22了。",
    },
    giraffe: {
        id: "giraffe",
        number: 9,
        status: {
            default: "/images/game/chapter2/game-objects/min-giraffe.png",
        },
        image: "/images/game/chapter2/game-objects/giraffe.png",
        title: "長頸鹿",
        description: "沒有養過長頸鹿？要買趁現在啊～",
        position: {
            x: 279,
            y: 227
        },
        size: {
            width: 251,
            height: 657,
        },
    },
    sleepbag: {
        id: "sleepbag",
        number: 15,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-sleepbag.png",
        },
        image: "/images/game/chapter2/game-objects/sleepbag.png",
        title: "睡袋",
        description: "流離失所讓你還是可以睡得安穩。",
        importance: "避難或停電時保暖、休息用，增加舒適度。",
        position: {
            x: 863,
            y: 662
        },
        size: {
            width: 367,
            height: 140,
        },
    },
    can: {
        id: "can",
        number: 4,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-can.png",
        },
        image: "/images/game/chapter2/game-objects/can.png",
        title: "乾糧、罐頭",
        description: "餓的時候必須充飢才有力氣。",
        importance: "存放不易腐壞的食物，災害時基本溫飽沒問題。",
        position: {
            x: 840,
            y: 200
        },
        size: {
            width: 203,
            height: 173,
        },
    },
    clock: {
        id: "clock",
        number: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-clock.png",
        },
        image: "/images/game/chapter2/game-objects/clock.png",
        title: "時鐘",
        description: "隨時知道自己活在幾時幾分相當重要。",
        position: {
            x: 1394,
            y: 367
        },
        size: {
            width: 168,
            height: 173,
        },
    },
    disc: {
        id: "disc",
        number: 6,
        status: {
            default: "/images/game/chapter2/game-objects/min-disc.png",
        },
        image: "/images/game/chapter2/game-objects/disc.png",
        title: "生菜海膽唱片",
        description: "人生不可以沒有音樂，遇到颱風也是。",
        position: {
            x: 1654,
            y: 297
        },
        size: {
            width: 137,
            height: 168,
        },
    },
    drum: {
        id: "drum",
        number: 7,
        status: {
            default: "/images/game/chapter2/game-objects/min-drum.png",
        },
        image: "/images/game/chapter2/game-objects/drum.png",
        title: "鼓，沒有鼓棒",
        description: "聽說打鼓好像可以擊退颱風耶？",
        position: {
            x: 1652,
            y: 586
        },
        size: {
            width: 156,
            height: 127,
        },
    },
    flashlight: {
        id: "flashlight",
        number: 8,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-flashlight.png",
        },
        image: "/images/game/chapter2/game-objects/flashlight.png",
        title: "手電筒",
        description: "照亮世界，照亮你我，你需要我。",
        importance: "停電時提供照明，行動更安全、方便。",
        position: {
            x: 104,
            y: 388
        },
        size: {
            width: 164,
            height: 96,
        },
    },

    gloves: {
        id: "gloves",
        number: 10,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-gloves.png",
        },
        image: "/images/game/chapter2/game-objects/gloves.png",
        title: "粗棉手套",
        description: "災害來時，避免雙手被碎石頭、碎玻璃割傷。",
        importance: "搬運或清理時保護雙手，避免割傷或受傷。",
        position: {
            x: 1478,
            y: 557
        },
        size: {
            width: 145,
            height: 110,
        },
    },
    goose: {
        id: "goose",
        number: 11,
        status: {
            default: "/images/game/chapter2/game-objects/min-goose.png",
        },
        image: "/images/game/chapter2/game-objects/goose.png",
        title: "神聖的鵝",
        description: "鵝？颱風天買鵝？？？？？？？",
        position: {
            x: 891,
            y: 452
        },
        size: {
            width: 134,
            height: 132,
        },
    },
    makeup: {
        id: "makeup",
        number: 12,
        status: {
            default: "/images/game/chapter2/game-objects/min-makeup.png",
        },
        image: "/images/game/chapter2/game-objects/makeup.png",
        title: "化妝品",
        description: "面對颱風即使躲在家還是要美美的。",
        position: {
            x: 682,
            y: 668
        },
        size: {
            width: 165,
            height: 135,
        },
    },
    plant: {
        id: "plant",
        number: 13,
        status: {
            default: "/images/game/chapter2/game-objects/min-plant.png",
        },
        image: "/images/game/chapter2/game-objects/plant.png",
        title: "植物",
        description: "在家擺設植物，可以提升生活格調。",
        position: {
            x: 125,
            y: 531
        },
        size: {
            width: 131,
            height: 176,
        },
    },
    rock: {
        id: "rock",
        number: 14,
        status: {
            default: "/images/game/chapter2/game-objects/min-rock.png",
        },
        image: "/images/game/chapter2/game-objects/rock.png",
        title: "神奇石頭",
        description: "帶著重重的石頭還可以順便重訓多好啊。",
        position: {
            x: 101,
            y: 776
        },
        size: {
            width: 193,
            height: 138,
        },
    },
    water: {
        id: "water",
        number: 16,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-water.png",
        },
        image: "/images/game/chapter2/game-objects/water.png",
        title: "水",
        description: "人不能沒有水，就像我不能沒有你。",
        importance: "備足飲用水，供水中斷時可維持生活需求。。",
        position: {
            x: 721,
            y: 177
        },
        size: {
            width: 88,
            height: 190,
        },
    },
    whistle: {
        id: "whistle",
        number: 17,
        stars: 5,
        status: {
            default: "/images/game/chapter2/game-objects/min-whistle.png",
        },
        image: "/images/game/chapter2/game-objects/whistle.png",
        title: "哨子，快買",
        description: "受困的時候可以讓大家知道你在哪。",
        importance: "受困時吹哨引起救援注意，增加獲救機會。",
        position: {
            x: 1446,
            y: 776
        },
        size: {
            width: 203,
            height: 115,
        },
    },

    

};

export default GAME_OBJECTS;
